import React from "react"
import { FormattedMessage } from "react-intl"
import useModal from "./UseModal"

const UseSaveChangesBeforeNavigateModal = () => {
    return useModal(
        {
            body: (
                <div>
                    <FormattedMessage
                        id="src.common.hooks.modal_save_changes_before_navigate"
                        defaultMessage="Do you want to save the current changes before leaving the page?"
                    />
                </div>
            ),
            bodyStyle: {display: "flex", justifyContent: "center", paddingTop: "40px", paddingBottom: "40px"},
            modalId: "save_changes_before_navigate_modal",
            centered: true,
            showConfirmBtn: true,
            confirmBtnText: <FormattedMessage
                id={"src.common.hooks.modal_save_changes_before_navigate.save"}
                defaultMessage={"Save"}/>,
            closeBtnText: <FormattedMessage
                id={"src.common.hooks.modal_save_changes_before_navigate.cancel"}
                defaultMessage={"Cancel"}/>,
        }
    )
}

export default UseSaveChangesBeforeNavigateModal



// WEBPACK FOOTER //
// ./src/common/hooks/UseSaveChangesBeforeNavigateModal.tsx